import { Link } from 'react-router-dom';
import { useDocumentTitle } from '../lib/useDocumentTitle.ts';

export default function NotFound() {
  useDocumentTitle('Not found');
  return (
    <main className="grid flex-1 place-items-center px-6 text-center">
      <div>
        <p className="eyebrow">Nothing here</p>
        <h1 className="font-display mt-3 text-4xl font-semibold">That link doesn't lead anywhere</h1>
        <p className="mt-3 text-muted">
          Check the address, or ask whoever set up the event for a fresh one.
        </p>
        <Link className="btn btn-ghost mt-8" to="/">
          Back to the start
        </Link>
      </div>
    </main>
  );
}
